import React from 'react';
import { BarChart2 } from 'lucide-react';

interface MetricsDisplayProps {
  metrics: Record<string, any>;
  title?: string;
  className?: string;
}

const MetricsDisplay: React.FC<MetricsDisplayProps> = ({ metrics, title = 'Metrics', className = '' }) => {
  const entries = Object.entries(metrics);
  if (entries.length === 0) return null;

  return (
    <div className={`p-3 sm:p-4 bg-teal-50/70 dark:bg-teal-950/30 border border-teal-200 dark:border-teal-900 rounded-xl ${className}`}>
      <p className="flex items-center gap-1.5 text-xs font-semibold text-teal-700 dark:text-teal-300 uppercase tracking-wider mb-2">
        <BarChart2 className="w-3.5 h-3.5" /> {title}
      </p>
      <div className="flex flex-wrap gap-2">
        {entries.map(([key, value]) => (
          <span key={key} className="inline-flex items-center gap-1 px-2.5 py-1 bg-white dark:bg-gray-900 border border-teal-200 dark:border-teal-900 rounded-md text-xs">
            <span className="text-teal-600 dark:text-teal-400 font-medium">{key}:</span>
            <span className="text-teal-900 dark:text-teal-100 font-semibold tabular-nums">
              {typeof value === 'object' ? JSON.stringify(value) : String(value)}
            </span>
          </span>
        ))}
      </div>
    </div>
  );
};

export default MetricsDisplay;
